/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="../../Scripts/raphael.js" />
/// <reference path="../../Content/vendor/ckeditor/ckeditor.js" />
/// <reference path="jsRenderHelper.js" />

window.JJK = window.JJK || {};

JJK.Aboverwaltung = function (aboVerwaltungMenu, SetAboArtenToContextUrl, aboArt, navigationAnzeigen, aboverwaltungURL, setMenueItemToContextUrl) {
	this.aboVerwaltungMenue = aboVerwaltungMenu;
	this.SetAboArtenToContextUrl = SetAboArtenToContextUrl;
	this.aboArt = aboArt;
	this.navigationAnzeigen = navigationAnzeigen;
	this.aboverwaltungURL = aboverwaltungURL;
	this.setMenueItemToContextUrl = setMenueItemToContextUrl;
	this.Init();
};

JJK.Aboverwaltung.prototype = {
	Init: function () {
		if (this.aboArt !== 'Keine') {
			if (this.aboArt === 'AboAuftrag') {
				/** @type {HTMLDivElement[]} */
				const sichtbareKategorien = Array.from(document.querySelectorAll('.kategorie-abos[data-kategorie-id]')).filter(elem => window.getComputedStyle(elem).display !== 'none');
				if (sichtbareKategorien.length) {
					this.Show(`AboAuftrag_${sichtbareKategorien[0].dataset.kategorieId}`);
				} else {
					this.Show('AboAuftrag');
				}
			} else {
				this.Show(this.aboArt);
			}
		} else {
			this.InitializePage();
		}

		$('select[name="GewaehltePraemie"]').on('change', function () {
			const templateId = $(this).closest('form').data('aboTemplateId');
			$(`#praemien-details-${templateId}`).find('.sp-artikel-card').removeClass('selected');
			$(`#sp-artikel-card-id-${templateId}-${this.value}`).addClass('selected');
		});

		$('ul[id^="AboAuftragmessageBox"]').each(function () {
			if (!$(this).children().length) {
				$(this).hide();
			}
		});
	},

	InitializePage: function () {
		const self = this;
		self.MenueItemsWithoutSubMenue(self.aboVerwaltungMenue).ForEach(function (vorgang) {
			self.InitFormular(vorgang);
		});
		self.MenueItemsWithSubMenue(self.aboVerwaltungMenue).ForEach(function (vorgang) {
			self.BindButtonEventsForMenueItemsWithSubMenue(vorgang);
		});
		self.BindMenueEvents();
	},

	/**
	 * @param {string} id -
	 * @returns {void}
	 */
	InitFormular: function (id) {
		if (id.startsWith('AboAuftrag_')) {
			$('#AboAuftrag').hide();
		} else {
			$(`#${id}`).hide();
		}
		this.BindButtonEventsForMenueItemsWithoutSubMenue(id);
	},

	MenueItemsWithoutSubMenue: function (menue) {
		let result = [];
		for (let i = 0; i < menue.length; i++) {
			if (menue[i].SubMenue.length === 0) {
				result.push(menue[i].Name);
			} else {
				result = result.concat(this.MenueItemsWithoutSubMenue(menue[i].SubMenue));
			}
		}
		return result;
	},

	IsTopLevelMenueItem: function (menue, id) {
		for (let i = 0; i < menue.length; i++) {
			if (menue[i].Name === id) {
				return true;
			}
		}
		return false;
	},

	MenueItemsWithSubMenue: function (menue) {
		let result = [];
		for (let i = 0; i < menue.length; i++) {
			if (menue[i].SubMenue.length > 0) {
				result.push(menue[i].Name);
				result = result.concat(this.MenueItemsWithSubMenue(menue[i].SubMenue));
			}
		}
		return result;
	},

	BindMenueEvents: function () {
		const self = this;
		$('#AboMenue')
			.off()
			.on('mouseleave', function () {
				for (let i = 0; i < self.aboVerwaltungMenue.length; i++) {
					if (self.aboVerwaltungMenue[i].SubMenue.length > 0) {
						self.HideSubMenueFor(self.aboVerwaltungMenue[i].Name);
					}
				}
			});

		for (let i = 0; i < self.aboVerwaltungMenue.length; i++) {
			if (self.aboVerwaltungMenue[i].SubMenue.length > 0) {
				$(`#SubMenueFor${self.aboVerwaltungMenue[i].Name}`)
					.off()
					.on('mouseleave', function () {
						self.HideSubMenue(this);
					});
			}

			self.HideSubMenueOnMouseOver(self.aboVerwaltungMenue[i].Name);
		}
	},

	HideSubMenueOnMouseOver: function (id) {
		const self = this;
		$(`#btn${id}`).on('mouseenter', function () {
			const that = this;
			// Per setTimeout ausführen, damit das Verstecken des Untermenüs nicht durchgeführt wird, bevor der Click-Event korrekt ausgelöst wurde:
			setTimeout(function () {
				const currentMenue = that.id.replace('btn', '');
				for (let j = 0; j < self.aboVerwaltungMenue.length; j++) {
					if (self.aboVerwaltungMenue[j].Name !== currentMenue) {
						self.HideSubMenueFor(self.aboVerwaltungMenue[j].Name);
					}
				}
				self.ShowSubMenueFor(currentMenue);
			}, 0);
		});
	},

	/**
	 * @param {string} divId -
	 * @param {function():any} success -
	 * @returns {void}
	 */
	Show: function (divId, success) {
		if (divId.startsWith('AboAuftrag_')) {
			document.getElementById('AboAuftrag').style.display = '';
			if ('AboAuftraegeListe' in window && 'kategorieWaehlen' in window.AboAuftraegeListe && typeof window.AboAuftraegeListe.kategorieWaehlen == 'function') {
				// beim Laden der Seite noch nicht vorhanden, aber auch nicht nötig
				const kategorieId = divId.slice('AboAuftrag_'.length);
				window.AboAuftraegeListe.kategorieWaehlen(kategorieId);
			}
		} else {
			$(`#${divId}`).show();
		}
		jjk.initSelect2($('select:not([multiple])', `#${this.aboArt}`));
	},

	BindButtonEventsForMenueItemsWithSubMenue: function (id) {
		const menueButton = $(`#btn${id}`);
		menueButton.off();
		if (!jjk.design.AboMenueInHauptmenueAnzeigen) {
			menueButton
				.removeClass('jjkButtonActive jjkButtonInactive')
				.addClass('jjkButton')
				.on('mouseenter', function () {
					$(this).removeClass('jjkButton jjkButtonInactive').addClass('jjkButtonActive').css('cursor', 'pointer');
				})
				.on('mouseleave', function () {
					$(this).removeClass('jjkButtonActive jjkButtonInactive').addClass('jjkButton');
				});
		}
		return menueButton;
	},

	HideSubMenueFor: function (menueId) {
		const subMenue = $(`#SubMenueFor${menueId}`);
		this.HideSubMenue(subMenue);
	},

	HideSubMenue: function (subMenue) {
		$(subMenue).css('visibility', 'collapse');
		$(subMenue).css('display', 'none');
		$('.AboVerwaltungSubWrapper.dim').removeClass('dim');
	},
};
